module.exports = __webpack_public_path__ + "img/system-en.1ec18933.png";